import { DashboardAppController } from '../controller/DashboardAppController';
import { BaseAdaptableWebComponent } from '../../framework/BaseAdaptableWebComponent';

export class DashboardAppWebComponent extends BaseAdaptableWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: DashboardAppController,
    });
  }
}
